import { render, staticRenderFns } from "./FormSetting.vue?vue&type=template&id=e221c25e&scoped=true&"
import script from "./FormSetting.vue?vue&type=script&lang=js&"
export * from "./FormSetting.vue?vue&type=script&lang=js&"
import style0 from "./FormSetting.vue?vue&type=style&index=0&id=e221c25e&scoped=true&lang=css&"
import style1 from "./FormSetting.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e221c25e",
  null
  
)

export default component.exports